var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 20,
  width: 20,
  viewBox: "5 3 30 34",
  xmlns: "http://www.w3.org/2000/svg",
  focusable: "false"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15 13.333h-3.333v3.334H15v-3.334zm6.667 0h-3.334v3.334h3.334v-3.334zm6.666 0H25v3.334h3.333v-3.334zm3.334-6.666H30V3.333h-3.333v3.334H13.333V3.333H10v3.334H8.333c-1.85 0-3.316 1.5-3.316 3.333L5 33.333a3.332 3.332 0 003.333 3.334h23.334c1.833 0 3.333-1.5 3.333-3.334V10c0-1.833-1.5-3.333-3.333-3.333zm0 26.666H8.333V10h23.334v23.333z"
})));
export default SvgCalendar;